<script setup lang="ts">
import { computed } from 'vue';

import { locale } from '@/locale';
import { analytics } from '@/scitylana';

import TruButton from '../TruButton.vue';
import TruCard from '../TruCard.vue';

import trupCertifiedBadgeBlue from '../../assets/images/TrupCertified_Badge_blue.png';
import trupCertifiedBadgeBlueEnCan from '../../assets/images/TrupCertified_Badge_blue_EN_CAN.png';
import trupCertifiedBadgeBlueFr from '../../assets/images/TrupCertified_Badge_blue_FR.png';
import trupCertifiedBadgeBlueSp from '../../assets/images/TrupCertified_Badge_blue_SP.png';
import trupCertifiedLogo from '../../assets/images/TrupCertified_logo.png';
import trupCertifiedLogoEnCan from '../../assets/images/TrupCertified_logo_EN_CAN.png';
import trupCertifiedLogoFr from '../../assets/images/TrupCertified_logo_FR.png';
import trupCertifiedLogoSp from '../../assets/images/TrupCertified_logo_SP.png';

const imageBadge = computed(() => {
    switch (locale.value) {
        case 'en-CA':
            return trupCertifiedBadgeBlueEnCan;
        case 'fr-CA':
            return trupCertifiedBadgeBlueFr;
        case 'es-US':
            return trupCertifiedBadgeBlueSp;
        default:
            return trupCertifiedBadgeBlue;
    }
});

const imageLogo = computed(() => {
    switch (locale.value) {
        case 'en-CA':
            return trupCertifiedLogoEnCan;
        case 'fr-CA':
            return trupCertifiedLogoFr;
        case 'es-US':
            return trupCertifiedLogoSp;
        default:
            return trupCertifiedLogo;
    }
});

function gotoGetTrupanionCertified() {
    analytics.home.certificationAndTraining();

    // eslint-disable-next-line vue/max-len
    window.open('https://certification.trupanion.com/?utm_campaign=trupanion-certification&utm_medium=vet-portal&utm_source=vet&utm_content=trupanion-certification&utm_term=widget');
}
</script>

<template>
    <div
        class="certification-and-training"
    >
        <TruCard :header="$t('dashboard.certificationAndTraining.header')">
            <div class="certification-and-training-content flex">
                <div class="main-wrapper">
                    <img
                        :alt="$t('dashboard.certificationAndTraining.altText')"
                        class="tru-certification-logo"
                        :src="imageLogo"
                    >

                    <div class="certification-desc">
                        <span class="highlight">
                            {{ $t('dashboard.certificationAndTraining.highlight') }}&ZeroWidthSpace;
                        </span>

                        <span class="body">
                            {{ $t('dashboard.certificationAndTraining.body') }}
                        </span>
                    </div>

                    <TruButton
                        secondary
                        size="xs"
                        @click="gotoGetTrupanionCertified"
                    >
                        {{ $t('dashboard.certificationAndTraining.button') }}
                    </TruButton>
                </div>

                <img
                    :alt="$t('dashboard.certificationAndTraining.badgeAltText')"
                    class="tru-certified-badge"
                    :src="imageBadge"
                >
            </div>
        </TruCard>
    </div>
</template>

<style scoped lang="scss">
@use '../../scss/typography' as *;

.certification-and-training {
    .main-wrapper {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        margin-right: 8rem;

        &>.tru-certification-logo {
            margin-bottom: 3rem;
            width: 25rem;
        }

        .tru-button {
            margin-top: 3rem;
        }
    }

    .certification-desc {
        @extend .desk-body-reg;

        .highlight {
            @extend .desk-body-bold;
            color: var(--tru-blue);
        }
    }

    .tru-certified-badge {
        flex-grow: 0;
        flex-shrink: 0;
        height: 20rem;
        width: 20rem;
    }
}
</style>
